import { IconButton } from '../iconButton';
import personIcon from 'assets/icons/person.svg';
import personWhiteIcon from 'assets/icons/person-white.svg';
import { FC } from 'react';
import { MAIN_COLOR } from 'shared/consts';

interface PersonButtonProps {
	onClick?: () => void;
	backgroundMain?: boolean;
	hide?: boolean;
	light?: boolean;
	disableTouch?: boolean;
}

export const PersonButton: FC<PersonButtonProps> = ({
	onClick,
	backgroundMain = false,
	light = false,
	hide = false,
	disableTouch = false,
}) => {
	return (
		<IconButton
			role="person-button"
			iconSrc={light ? personWhiteIcon : personIcon}
			hide={hide}
			onClick={onClick}
			disableTouch={disableTouch}
			styles={{
				background: backgroundMain ? MAIN_COLOR : 'transparent',
			}}
		/>
	);
};
